export default __webpack_public_path__ + "static/media/img888.e632d6c8.png";